var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avatar"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_0_36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check",
    d: "M16.8863 8.38847C17.2241 8.72018 17.2289 9.26287 16.8972 9.60061L11.0044 15.6006C10.8432 15.7647 10.6229 15.8571 10.3928 15.8571C10.1628 15.8571 9.94248 15.7647 9.78131 15.6006L7.10274 12.8732C6.77105 12.5354 6.77595 11.9927 7.1137 11.661C7.45144 11.3293 7.99413 11.3342 8.32583 11.672L10.3929 13.7767L15.6742 8.39939C16.0059 8.06166 16.5486 8.05677 16.8863 8.38847Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_36",
    x1: 27.7954,
    y1: 4.79457,
    x2: 1.82102,
    y2: 23.5636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E17200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepDone);
export default __webpack_public_path__ + "static/media/step-done.24ad689c619d3ab9407c5db92aa3772a.svg";
export { ForwardRef as ReactComponent };